import { Component, OnInit } from '@angular/core';
import { GoalsCreateModalComponent } from '../goals-modals/goals-create-modal/goals-create-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { GoalsModel, RefreshEvents } from 'src/app/models/goals.model';
import { GoalService } from 'src/app/services/goal.service';
import { Subject, takeUntil } from 'rxjs';
import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-goals',
  templateUrl: './goals.component.html',
  styleUrls: ['./goals.component.scss']
})
export class GoalsComponent implements OnInit {

  goalsInProgress = 0;
  goalsAtRisk = 0;
  isOverDue = false;
  allStudentGoalsData: GoalsModel[] = [];
  currentDate = new Date();
  refreshEvent = RefreshEvents;
  
  private destroyed$ = new Subject();

  constructor(private _dialog: MatDialog,
              private _goalService: GoalService,
              private _datePipe: DatePipe,
              private _snackbar: MatSnackBar,
              private _translator: TranslateService,
            ) { }

  ngOnInit(): void {
     this.getAllStudentGoalsData();
  }

  getAllStudentGoalsData(): void {
    this._goalService.getAllStudentGoals()
    .pipe(takeUntil(this.destroyed$))
    .subscribe({
      next: (data: GoalsModel[]) => {
        this.allStudentGoalsData = data;
        this.goalsInProgress = this.allStudentGoalsData.length;
        this.calculateGoalsAtRisk();
      },
      error: (error: any) => {
        console.error('An error occurred while fetching goals data:', error);
      }
    });
  }

  refreshData(refresh: any) {
    switch(refresh) {
      case this.refreshEvent.REFRESH_RISK_COUNTER:
        this.calculateGoalsAtRisk();
      break;
      case this.refreshEvent.REFRESH_ALL_GOALS:
        this.getAllStudentGoalsData();
      break;
      default:
        this.getAllStudentGoalsData();
    }
  }

  calculateGoalsAtRisk() {
    this.goalsAtRisk = 0;
    for(const goal of this.allStudentGoalsData) {
      for(const task of goal.goalTasks) {
        const dueDate = new Date(task.due);
        if(!task.isDone && dueDate < this.currentDate) {
          this.goalsAtRisk++;
          break;     
        }
      }
    }
  }

  onCreateGoal() {
    let ref = this._dialog.open(GoalsCreateModalComponent, {
      width: '700px',
      maxHeight: '100vh',
      panelClass: 'create-dialog',
      data: {}
    });

    ref.afterClosed().subscribe(val => {
      
      if(val) {
        let formattedDate = this._datePipe.transform(val.formValues.goal.due, 'shortDate')
        const goalModel: GoalsModel = {
          name: val.formValues.goal.name,
          due: formattedDate,
          description: val.formValues.goal.description,
          goalTasks: val.formValues.tasks
        };

        this._goalService.createStudentGoal(goalModel).pipe(
          takeUntil(this.destroyed$))
          .subscribe({
            next: (data) => {
              this._snackbar.open(
                this._translator.instant(
                  'The goal has been successfully created.'
                ),
                this._translator.instant('Dismiss'),
                {
                  duration: 3000,
                }
              );
              this.getAllStudentGoalsData();
            },
            error: (error: any) => {
              console.log("There was an error creating your goal. ", error);
              this._snackbar.open(
                this._translator.instant(
                  'There was an error creating your goal.'
                ),
                this._translator.instant('Dismiss'),
                {
                  duration: 3000,
                }
              );
            }
          })
      } 
    })
  }

  ngOnDestroy() 
  {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
